import clientService from '../apiClient';
import { Notification } from '../components/Notification';
import { FILE_URL } from './apiEndpoints';
import { genWorkspaceHeader } from './constants';

export const fetchFileDetail = async (id, workspace_id) => {
  try {
    const url = FILE_URL;
    const response = await clientService.get(`${url}/${id}`, {
      headers: genWorkspaceHeader(workspace_id),
    });

    return response.data;
  } catch (error) {
    Notification.error('Something went Wrong');
  }
};
